import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

export function useLogWeightlossTracks(asPath) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const url = new URL(window.location.href);
    const pathname = asPath.split('?')[0];

    // Only run on weight-loss pages
    if (!pathname.includes('/weight-loss')) return;

    // Only run if utm_source exists
    const utm_source = url.searchParams.get('utm_source');
    if (!utm_source) return;

    // ---- Check if already saved (first touch) ----
    if (localStorage.getItem('first_touch_weightloss')) return;

    // ---- Create visitor ID once ----
    let vid = document.cookie.split('; ').find((x) => x.startsWith('nb_vid='));
    vid = vid ? vid.split('=')[1] : uuidv4();
    document.cookie = `nb_vid=${vid}; path=/; SameSite=Lax`;

    // ---- Build attribution object ----
    const data = {
      visitor_id: vid,
      utm_source,
      utm_medium: url.searchParams.get('utm_medium') || null,
      utm_campaign: url.searchParams.get('utm_campaign') || null,
      path: url.pathname + url.search,
    };

    // ---- Store locally so we don't log again ----
    localStorage.setItem('first_touch_weightloss', '1');

    // ---- Send to Parse ----
    console.log('Sending to parse');
    fetch(`https://24doc.b4a.io/classes/Weightloss_Tracks`, {
      method: 'POST',
      headers: {
        'X-Parse-Application-Id': process.env.NEXT_PUBLIC_PARSE_APP_ID,
        'X-Parse-Javascript-Key': process.env.NEXT_PUBLIC_PARSE_JS_KEY,

        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }, [asPath]);
}
